import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

function AccountMenuItem({
	isMobile,
	theme,
	label,
	icon,
	onClick,
	withTopOffset = false,
}) {
	const styles = {
		menuItem: {
			alignItems: 'flex-start',
			columnGap: theme.spacing(0.25),
			py: `${theme.spacing(0.25)} !important`,
			minHeight: `${theme.spacing(4)} !important`,
			'& .MuiListItemText-root': {
				marginTop: '0 !important',
				marginBottom: '0 !important',
			},
		},
		menuItemDesktop: {
			fontSize: theme.palette.textSize.sizeMd,
			marginTop: withTopOffset ? theme.spacing(-2) : undefined,
		},
		itemIcon: {
			minWidth: theme.spacing(2.75),
			color: theme.palette.action.disabled,
			alignSelf: 'flex-start',
		},
		itemText: { my: 0 },
	};

	return (
		<MenuItem
			onClick={onClick}
			aria-label={isMobile ? undefined : label}
			tabIndex={isMobile ? undefined : 0}
			dense
			sx={styles.menuItem}
			style={isMobile ? undefined : styles.menuItemDesktop}
		>
			<ListItemIcon sx={styles.itemIcon}>{icon}</ListItemIcon>
			<ListItemText
				sx={styles.itemText}
				primary={label}
				primaryTypographyProps={{
					fontSize: isMobile
						? theme.palette.textSize.sizeLg
						: theme.palette.textSize.sizeMd,
					lineHeight: 1.2,
				}}
			/>
		</MenuItem>
	);
}

AccountMenuItem.propTypes = {
	isMobile: PropTypes.bool.isRequired,
	theme: PropTypes.object.isRequired,
	label: PropTypes.string.isRequired,
	icon: PropTypes.node.isRequired,
	onClick: PropTypes.func.isRequired,
	withTopOffset: PropTypes.bool,
};

export default AccountMenuItem;
